import { createUserWithEmailAndPassword } from "firebase/auth";
import React, { useState } from "react";
import { CryptoState } from "../../CryptoContext";
import { auth } from "../../firebase";

const Signup = ({ handleClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const { setAlert } = CryptoState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setAlert({
        open: true,
        message: "Password, do not match",
        type: "error",
      });
      return;
    }
    if (!email || !password || !confirmPassword) {
      setAlert({
        open: true,
        message: "Plase fill all the Fields",
        type: "error",
      });
      return;
    }

    try {
      const result = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      setAlert({
        open: true,
        message: `Sign Up Successful. Welcome ${result.user.email}`,
        type: "success",
      });
      handleClose();
    } catch (error) {
      setAlert({
        open: true,
        message: error.message,
        type: "error",
      });
      return;
    }
  };
  return (
    <form className="d-flex flex-column p-3 gap-3">
      <input
        placeholder="Enter email"
        required
        className="form-control shadow"
        type="email"
        label="Enter email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        className="form-control shadow"
        placeholder="Enter password"
        type="password"
        required
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <input
        className="form-control shadow"
        required
        type="password"
        placeholder="Confirm password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      <div className="d-grid">
        <button
          placeholder="Enter password"
          type="submit"
          onClick={handleSubmit}
          className="btn border -bg-secondary"
        >
          Sign Up
        </button>
      </div>
    </form>
  );
};

export default Signup;
